"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_EVENT_ERROR_PREFIX = exports.ERROR_EVENT_END_NOT_FOUND = exports.ERROR_EVENT_START_NOT_FOUND = exports.EVENT_END_SUFFIX = exports.EVENT_START_SUFFIX = void 0;
exports.EVENT_START_SUFFIX = '_start';
exports.EVENT_END_SUFFIX = '_end';
exports.ERROR_EVENT_START_NOT_FOUND = 'Event start timestamp not found';
exports.ERROR_EVENT_END_NOT_FOUND = 'Event end timestamp not found';
exports.ERROR_EVENT_ERROR_PREFIX = 'Error occurred while emit event duration metric';
